import { cometDConfig } from '../../../../config'
import lib from 'cometd'
import { useEffect } from 'react'

export default function useCometD (callback) {
  useEffect(() => {
    const { options, subChannel, pubChannel, handshakeProps, ventureIsSupported } = cometDConfig
    if (ventureIsSupported) {
      const cometD = new lib.CometD()
      cometD.configure(options)

      function messageCallback (message) {
        try {
          callback(JSON.parse(message.data))
        } catch (err) {
          console.log(err)
        }
      }

      function handshakeCallback (handshakeReply) {
        if (handshakeReply.successful) {
          cometD.subscribe(subChannel, messageCallback)
          cometD.publish(pubChannel, { action: 'LOBBY_FEED' })
        } else {
          console.warn(
            `cometD Handshake failed ${handshakeReply.error} on ${handshakeReply.channel}`
          )
        }
      }

      cometD.handshake(handshakeProps, handshakeCallback)
      return () => {
        cometD.disconnect(() => console.log('Disconnecting bingo feed'))
      }
    }
  }, [])
}
